import { csatStore as e } from "./csatStore.mjs";
import { csatQueryKeys as t } from "./queryKeys.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { csatApi as i } from "@maat/api-csat";
//#region src/useDismissCsatMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: (e) => i.dismissPrompt(e.promptId),
		onSettled: (n, r, { feature: i }) => {
			a.setQueryData(t.eligibility(i), { eligible: !1 }), e.close();
		}
	});
};
//#endregion
export { a as useDismissCsatMutation };
